import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideClientOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="取引先管理"
      description="取引先企業の登録・更新・検索を行う管理機能です。管理者・管理部門・課長が操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="client/register">新規取引先を登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新しい取引先企業の情報を登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="client/bulk-register">取引先を一括登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              CSVファイルを使用して複数の取引先を一括で登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="client/update">取引先情報を更新する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存取引先の企業情報を更新します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="client/detail">取引先の詳細情報を確認する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              取引先の登録情報を詳細画面で確認します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="client/search">取引先を検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定して取引先を検索・絞り込みます。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideClientOverview;
